import { Button } from '@brighterion/br-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { handleOnClickEvent, handleKeyEvent } from 'Utils';
import styles from './EditOverrideBtn.css';

type Props = {
    id: string;
    showButton?: boolean;
    selectedRowId: string;
};

const EditOverrideBtn = ({ id, showButton, selectedRowId }: Props) => {
    const { t } = useTranslation();
    const history = useHistory();
    const location = useLocation();

    const editRule = () => {
        history.push(`${location.pathname}/edit-tenant-group-override/${id}?selectedRowId=${selectedRowId}`);
    };

    return (
        <div className={styles.container}>
            {showButton && (
                <Button
                    dataTestId='edit-button'
                    variant='contextual-secondary'
                    onClick={handleOnClickEvent(editRule)}
                    onKeyDown={handleKeyEvent(editRule)}
                >
                    {t('Edit Override')}
                </Button>
            )}
        </div>
    );
};

export default EditOverrideBtn;
